import { render, staticRenderFns } from "./MusicIcon.vue?vue&type=template&id=9a96bb6e&scoped=true&"
import script from "./MusicIcon.vue?vue&type=script&lang=js&"
export * from "./MusicIcon.vue?vue&type=script&lang=js&"
import style0 from "./MusicIcon.vue?vue&type=style&index=0&id=9a96bb6e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a96bb6e",
  null
  
)

export default component.exports